module.exports = __webpack_public_path__ + "img/doc.deef8893.svg";